import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { EmailNotificationPreferenceStateClass } from './interfaces/emailNotificationPreferenceeStateClass';

const initialState: EmailNotificationPreferenceStateClass = {
    isLoading: true,
    status: 'idle',
    EmailNotificationPreferenceList: [],
    selectedRecord: {},
    isReload : false
}
interface IThunkApi {
    state: {
        emailNotificationPreference: EmailNotificationPreferenceStateClass;
    },
}
export const getvueAccountEMailNotificationPreferencessAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'emailNotificationPreference/getvueAccountEMailNotificationPreferencess',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/EmailNotifications', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

    export const UpdateAccountEmailNotificationPreferenceAsync = createAsyncThunk
    <any,{data: any },IThunkApi>
    (
        "emailNotificationPreference/UpdateAccountEmailNotificationPreference",
        async (arg,thunkApi)=>{
            console.log('emailid', arg)
            const {data} = arg;
            const response = await fetchAPI("api/v2/EmailNotifications/NotificationType" ,"PUT", data, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )


    export const emailNotificationPreferenceSlice = createSlice({
        name: 'emailNotificationPreference',
        initialState,
        reducers:{
            resetSelectedRecordObjectInState:(state)=>{
                state.selectedRecord = {}
            },
            checkedState: (state, action) => {
                const {AccountEMailNotificationPreferenceId,FieldName} = action.payload;
                const currentindex = state.EmailNotificationPreferenceList.findIndex((item) => item.AccountEMailNotificationPreferenceId == AccountEMailNotificationPreferenceId);
                const newArray = [...state.EmailNotificationPreferenceList];
                newArray[currentindex] = { ...newArray[currentindex], [FieldName]: true};
                state.EmailNotificationPreferenceList = newArray;       
            },
            unCheckedState: (state, action) => {
                const {AccountEMailNotificationPreferenceId,FieldName} = action.payload;
                const currentindex = state.EmailNotificationPreferenceList.findIndex((item) => item.AccountEMailNotificationPreferenceId == AccountEMailNotificationPreferenceId);
                const newArray = [...state.EmailNotificationPreferenceList];
                newArray[currentindex] = { ...newArray[currentindex], [FieldName]: false};
                state.EmailNotificationPreferenceList = newArray;       
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(getvueAccountEMailNotificationPreferencessAsync.pending, (state) => {
                    state.status = 'loading';
                    state.isLoading = true; 
                })
                .addCase(getvueAccountEMailNotificationPreferencessAsync.fulfilled, (state, { payload }) => {
                    state.status = 'idle';
                    state.EmailNotificationPreferenceList = payload.Data;
                    state.isReload = false;
                    state.selectedRecord = {};
                    state.isLoading = false;
                })
                .addCase(getvueAccountEMailNotificationPreferencessAsync.rejected, (state) => {
                    state.status = 'failed';
                    state.isLoading = false;
                })

                .addCase(UpdateAccountEmailNotificationPreferenceAsync.pending, (state) => {
                    state.status = 'loading';
                    state.isLoading = true;
                })
                .addCase(UpdateAccountEmailNotificationPreferenceAsync.fulfilled, (state, { payload }) => {
                    state.status = 'idle';        
                    state.isReload = true;
                    state.isLoading = false;
                })
                .addCase(UpdateAccountEmailNotificationPreferenceAsync.rejected, (state) => {
                    state.status = 'failed';
                    state.isLoading = false;
                })
             
        }
    })

     export const {resetSelectedRecordObjectInState,checkedState,unCheckedState} = emailNotificationPreferenceSlice.actions
     export const emailNotificationPreferenceeStateClass = (state: RootState) => state.emailNotificationPreference
     export default emailNotificationPreferenceSlice.reducer